// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9554) return "static/chunks/9554-bcbd2cc4dcc6112f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"646":"f8e1adc8c5f7b0b3","1821":"834a8eb2bf899d20","3767":"79fde35b44cf698f","5644":"d862947d3fe41ceb","6943":"93c58a59a06658bc","8650":"57462fb87d9f65fa","8718":"1e90379b34b4a96a","9429":"6c82d5866d7a7aee"}[chunkId] + ".js";
};